import type {RouteRecordRaw} from "vue-router";
import {isSalesAccount} from "@/utilities/authorization.ts";

const referralRoutes: RouteRecordRaw[] = [
  {
    name: 'referral',
    path: '/referral',
    component: () => import('@/views/referral/ReferralHome.vue'),
    beforeEnter: () => isSalesAccount(),
  },
  {
    name: 'referral-transaction-history',
    path: '/referral/transaction/:id(\\d+)',
    component: () => import('@/views/referral/TransactionHistory.vue'),
    beforeEnter: () => isSalesAccount(),
  },
]

export default referralRoutes